function card(discussion, _temp) {
  let {
    featured = false,
    label = 'Сейчас обсуждают'
  } = _temp === void 0 ? {} : _temp;
  return m(`article.dc-popcard${featured ? '.dc-popcard--featured' : ''}`, {
    key: discussion.id
  }, [m('div.dc-popcard__body', [m('div.dc-popcard__type', [m('span.dc-badge.dc-badge--slate', label)]), m('h3.dc-popcard__title', m('a', {
    href: discussion.url
  }, discussion.title)), m('p.dc-popcard__excerpt', discussion.excerpt || 'Практическое обсуждение с ответами и опытом участников DevConnect.'), m('div.dc-popcard__meta', [m('span.dc-popcard__author', discussion.author.username), m('span.dc-popcard__stats', [m('span', `💬 ${discussion.comments}`), m('span', `◉ ${discussion.views}`)])])])]);
}
export default function Popular(_ref) {
  let {
    discussions,
    editorChoice = null,
    periodDays = 7
  } = _ref;
  // Редакторская рекомендация не участвует в автоматическом рейтинге.
  // Поэтому пользователь всегда понимает, что выбрано вручную, а что поднялось активностью сообщества.
  const items = editorChoice ? [card(editorChoice, {
    featured: true,
    label: 'Выбор редакции'
  }), ...discussions.map(discussion => card(discussion))] : discussions.map(discussion => card(discussion));
  return m('section.dc-section.dc-section--tight', [m('div.dc-container', [m('header.dc-section-head', [m('div', [m('h2', 'Популярное сейчас'), m('p', `Свежие ответы и участники за ${Number(periodDays) || 7} дней`)]), m('a.dc-link', {
    href: '/all'
  }, 'Все обсуждения →')]), m(`div.dc-popular__grid${editorChoice ? '' : '.dc-popular__grid--without-choice'}`, items.length ? items : m('article.dc-card.dc-empty', 'За выбранный период активных обсуждений пока нет.'))])]);
}
flarum.reg.add('devconnect-portal', 'forum/components/Popular', Popular);